import { useNavigate } from 'react-router-dom';

const policySections = [
  {
    number: '01',
    title: '個人情報の取得',
    body: '当社は、お問い合わせフォームのご利用、各種ご相談への対応、営業支援サービスの提供に必要な範囲で、お名前、会社名、メールアドレス、電話番号、お問い合わせ内容等の情報を取得することがあります。'
  },
  {
    number: '02',
    title: '利用目的',
    items: [
      'お問い合わせへの回答および必要なご連絡のため',
      '営業代行、営業コンサルティング、人材育成等のサービス提供のため',
      'ご相談内容の確認、提案内容の作成および改善のため',
      'サービス品質の向上、運営上必要な分析のため',
      '法令等に基づく対応のため'
    ]
  },
  {
    number: '03',
    title: '第三者提供',
    body: '当社は、次の場合を除き、お客様の個人情報を第三者に開示または提供いたしません。',
    items: [
      'ご本人の同意がある場合',
      '法令に基づく場合',
      '人の生命、身体または財産の保護のために必要がある場合'
    ]
  },
  {
    number: '04',
    title: '安全管理',
    body: '当社は、個人情報への不正アクセス、漏えい、滅失、き損等を防止するため、必要かつ適切な安全管理措置を講じます。'
  },
  {
    number: '05',
    title: '開示・訂正・削除等',
    body: 'ご本人から自己の個人情報について、開示、訂正、追加、削除、利用停止等の請求があった場合には、ご本人確認のうえ、法令に基づき適切に対応いたします。'
  },
  {
    number: '06',
    title: 'Cookie等の利用',
    body: '当サイトでは、利便性向上や利用状況把握のためにCookie等を利用する場合があります。ブラウザの設定によりCookieを無効化することも可能ですが、一部機能が正常に利用できない場合があります。'
  },
  {
    number: '07',
    title: 'プライバシーポリシーの改定',
    body: '当社は、法令の改正や運営上の必要に応じて、本ポリシーの内容を変更することがあります。変更後の内容は、本サイトに掲載した時点で効力を生じるものとします。'
  }
];

export default function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
      <header className="relative overflow-hidden border-b border-white/10">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute -top-24 left-0 h-72 w-72 rounded-full bg-blue-500/30 blur-3xl"></div>
          <div className="absolute right-0 top-0 h-80 w-80 rounded-full bg-cyan-400/20 blur-3xl"></div>
        </div>

        <div className="relative mx-auto max-w-5xl px-6 py-10">
          <button
            onClick={() => navigate('/')}
            className="mb-8 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-5 py-2 text-sm font-medium text-blue-200 transition-colors hover:bg-white/10 hover:text-white cursor-pointer"
          >
            <i className="ri-arrow-left-line text-lg"></i>
            <span>ホームに戻る</span>
          </button>

          <div className="grid gap-8 md:grid-cols-[1.3fr_0.7fr] md:items-end">
            <div>
              <div className="mb-4 inline-flex rounded-full border border-blue-400/20 bg-blue-500/10 px-4 py-2 text-xs font-bold tracking-[0.2em] text-blue-200">
                PRIVACY POLICY
              </div>
              <h1 className="mb-5 text-4xl font-bold leading-tight text-white md:text-6xl">
                個人情報の取り扱いを
                <span className="bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent">明確にご案内</span>
              </h1>
              <p className="max-w-2xl text-base leading-8 text-slate-300 md:text-lg">
                合同会社FullBetは、お問い合わせや営業支援のご相談を通じて取得する情報について、
                法令に基づき適切かつ慎重に取り扱います。以下に、個人情報の取得、利用目的、安全管理等の基本方針を定めます。
              </p>
            </div>

            <div className="rounded-3xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm">
              <div className="mb-4 text-sm font-bold tracking-[0.2em] text-slate-300">POLICY SUMMARY</div>
              <div className="space-y-4 text-sm leading-7 text-slate-200">
                <div>
                  <div className="font-semibold text-white">事業者</div>
                  <div>合同会社FullBet</div>
                </div>
                <div>
                  <div className="font-semibold text-white">所在地</div>
                  <div>〒700-0945 岡山市南区新保441番地17 PROMENA de SOU 101</div>
                </div>
                <div>
                  <div className="font-semibold text-white">主な取得情報</div>
                  <div>お名前、会社名、メールアドレス、電話番号、お問い合わせ内容</div>
                </div>
                <div>
                  <div className="font-semibold text-white">お問い合わせ窓口</div>
                  <div>当サイトのお問い合わせフォーム</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-6 py-16">
        <div className="mb-12 rounded-3xl border border-white/10 bg-white/5 p-8 backdrop-blur-sm">
          <p className="text-base leading-8 text-slate-200">
            合同会社FullBet（以下「当社」といいます）は、お客様の個人情報の重要性を認識し、
            個人情報の保護に関する法律その他の関連法令を遵守するとともに、以下の方針に基づき適切に取り扱います。
          </p>
        </div>

        <div className="space-y-6">
          {policySections.map((section) => (
            <section
              key={section.number}
              className="rounded-3xl border border-white/10 bg-white p-8 text-slate-800 shadow-2xl shadow-slate-950/20"
            >
              <div className="mb-6 flex items-start gap-5">
                <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-500 to-cyan-400 text-lg font-bold text-white">
                  {section.number}
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-slate-900">{section.title}</h2>
                  {section.body && <p className="mt-3 leading-8 text-slate-600">{section.body}</p>}
                </div>
              </div>

              {section.items && (
                <div className="space-y-3">
                  {section.items.map((item) => (
                    <div key={item} className="flex gap-3 rounded-2xl bg-slate-50 px-4 py-4">
                      <i className="ri-check-line mt-1 text-lg text-blue-500"></i>
                      <p className="leading-7 text-slate-700">{item}</p>
                    </div>
                  ))}
                </div>
              )}
            </section>
          ))}
        </div>

        <section className="mt-8 rounded-3xl border border-blue-400/20 bg-gradient-to-r from-blue-500/10 to-cyan-400/10 p-8">
          <div className="mb-4 text-sm font-bold tracking-[0.2em] text-blue-200">CONTACT</div>
          <h2 className="mb-4 text-2xl font-bold text-white">お問い合わせ窓口</h2>
          <div className="grid gap-6 md:grid-cols-2">
            <div className="rounded-2xl border border-white/10 bg-white/5 p-6">
              <div className="mb-2 text-sm text-slate-300">事業者名</div>
              <div className="text-lg font-semibold text-white">合同会社FullBet</div>
            </div>
            <div className="rounded-2xl border border-white/10 bg-white/5 p-6">
              <div className="mb-2 text-sm text-slate-300">所在地</div>
              <div className="text-lg font-semibold text-white">〒700-0945 岡山市南区新保441番地17 PROMENA de SOU 101</div>
            </div>
            <div className="rounded-2xl border border-white/10 bg-white/5 p-6 md:col-span-2">
              <div className="mb-2 text-sm text-slate-300">お問い合わせ方法</div>
              <div className="text-lg font-semibold text-white">当サイトのお問い合わせフォームよりご連絡ください</div>
            </div>
          </div>
          <div className="mt-6 text-right text-sm text-slate-300">制定日: 2024年10月16日</div>
        </section>
      </main>
    </div>
  );
}
